import useAuth from '@components/_hooks/useAuth';
import useGlobalSettings from '@components/_hooks/useGlobalSettings';
import useSalesTelephone from '@components/_hooks/useSalesTelephone';
import { portalRoutes } from '@components/config/axiosClient';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
const AlertComponent = dynamic(() => import('@components/Components/Reusables/AlertComponent'), {ssr: false})
const Tel = dynamic(() => import('@components/Components/Reusables/Tel'), {ssr: false})
const BoxContainerV2 = dynamic(() => import('@components/Components/Reusables/BoxContainerV2'), {ssr: false})


export default function MaintenanceMessage({showSideNav}) {
    const {getSetting} = useGlobalSettings();
    const {isAuthenticated} = useAuth();
    const router = useRouter();
    const inPortalRoute = portalRoutes.find(route => router.pathname.startsWith(route));
    const sales_telephone = useSalesTelephone();
    const displayMaintenanceMessage = getSetting('maintenance_message', 'yes') == 'yes';
    if(!displayMaintenanceMessage) return null;

    const hideMessage = (inPortalRoute || !displayMaintenanceMessage || isAuthenticated);
    if(hideMessage) return null;

    const props = showSideNav ? {
        template_page_settings: {layout: 'wide'},
        custom_layout: 'wide'
    } : {}

    return (
        <BoxContainerV2
            {...props}
        >
            <AlertComponent
                className="mt-2"
                severity="error"
                title={
                    <>
                        We're sorry — online quote requests are temporarily unavailable due to technical issues beyond our control. Please call us on <strong><Tel tel={sales_telephone}/></strong> and our team will be happy to assist you. Thank you for your understanding.
                    </>
                }
            />
        </BoxContainerV2>
    )
}
